<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-商会会员-添加
    -->
    <el-dialog
    title="添加商城数据互通"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :append-to-body="true"
    
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" label-width="100px">
  
      <el-form-item label="商城名称" prop="name"  :rules="[{ required: true, message: '请输入商城名称' }]">
        <el-input v-model="form.name" 
        placeholder="请输入商城名称" class="max-w460"
       
        ></el-input>
      </el-form-item>

      

         <!-- 关联会员 -->
        <el-form-item label="选择手机端管理" >
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">关联手机端管理</el-button>
          <div v-if="form.shop_user_id!=''" class="img">
            <div>{{ user_info.real_name }}</div>
          </div>
        </el-row>
        <el-button @click="remove" v-if="form.shop_user_id!=''">移除手机端管理</el-button>
      </el-form-item>

           <!-- 关联api -->
        <el-form-item label="选择API" >
        <el-row>
          <el-button @click="addApiClick" icon="el-icon-plus">关联API</el-button>
          <div v-if="form.api_id!=''" class="img">
            <div>{{ api_info.name }}</div>
          </div>
        </el-row>
        <el-button @click="removeApi" v-if="form.api_id!=''">移除API</el-button>
      </el-form-item>

     

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <GetShopUser :is_open="open_user" :multi="false" @close="closeDialogFunc"></GetShopUser>
    <GetApi :is_open="open_api" :multi="false" @close="closeDialogFuncApi"></GetApi>
</el-dialog>
  
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import RegionagentApi from '@/api/datashare.js';
import Upload from '@/components/file/Upload';
import GetShopUser from '@/components/user/GetShopUser.vue';
import GetApi from '@/components/user/Api.vue';
var timestamp=new Date().toLocaleDateString();

export default {
  components: {
    Upload,
    Getpoint,
    GetShopUser,
    GetApi
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        shop_user_id:0,
        api_id:0,
      },
      loading: false,

      dialogVisible:false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      category:[],
      user_info:{
        real_name:""
      },
      open_user:false,
      open_api:false,
      api_info:{
        name:""
      },
    };
  },
  created() {
    this.dialogVisible = this.open_add;

  },
  props: ["open_add"],
  methods: {
    /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.shop_user_id = e.params.shop_user_id;
        }
        this.open_user = false;
      },
      remove(){
        this.user_info = {
           real_name:""
        }
        this.form.shop_user_id = "";
      },

      addApiClick() {
        this.open_api = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFuncApi(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.api_info = e.params;
          this.form.api_id = e.params.api_id;
        }
        this.open_api = false;
      },
      removeApi(){
        this.api_info = {
           name:""
        }
        this.form.api_id = "";
      },

   


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    
    

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RegionagentApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/datashare/shop/part/add.vue